import { Select } from "antd";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Widget, WidgetLoader } from "datastake-daf/dist/components";
import OverviewWidget from "../../components/OverviewWidget";

const filterOptions = [
  { label: 'Own data', value: 'own' },
  { label: 'DataStore::acquired-data', value: 'acquired' },
  { label: 'DataStore::consolidated-data', value: 'consolidated' },
]

export default function Overview({
  data = {},
  loading,
}) {
  const { t } = useTranslation();
  const [filter, setFilter] = useState('own');

  const config = useMemo(() => [
    { label: t('Information Subjects'), value: data[filter]?.subjects, },
    { label: t('DataStore::granular-data-points'), value: data[filter]?.datapoints, },
    { label: t('DataStore::data-links'), value: data[filter]?.datalinks, },
  ], [data, t, filter]);

  return (
    <Widget
      title={t('DataStore::overview')}
      className="with-border-header flex-1"
      addedHeader={(
        <>
          <div className="flex-1" />
          <div>
            <Select
              value={filter}
              className='custom-select white'
              onChange={(val) => setFilter(val)}
              style={{ minWidth: 165, maxWidth: 165 }}
            >
              {filterOptions.map((o) => (
                <Select.Option value={o.value} key={o.value}>
                  {t(o.label)}
                </Select.Option>
              ))}
            </Select>
          </div>
        </>
      )}
    >
      {!!loading && <WidgetLoader background="white" />}
      <OverviewWidget config={config} />
    </Widget>
  )
}
